import type { ReactNode } from 'react';

export interface ReceiptsGroupProps {
  children: ReactNode;
}

/**
 * Section 4 of /review V2 (spec §5.Section 4). Container around the three
 * collapsible Receipts blocks. Children own their open/closed state; this
 * wrapper only provides the eyebrow and stack spacing.
 */
export function ReceiptsGroup({ children }: ReceiptsGroupProps) {
  return (
    <section className="review-receipts" aria-label="Receipts">
      <p className="review-receipts__eyebrow">Receipts</p>
      {children}
    </section>
  );
}
